import React from "react";
import { FacilityOrderTemplatePatientCreateTemplate } from "themes/application/facility-order/pages";
import { observer } from "mobx-react";
import { FacilityOrderTemplatePatientCreateViewStore } from "application/facility-order/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new FacilityOrderTemplatePatientCreateViewStore(rootStore), "facilityOrderTemplatePatientCreateViewStore")
@observer
class FacilityOrderTemplatePatientCreate extends React.Component {
	render() {
		return <FacilityOrderTemplatePatientCreateTemplate {...this.props} />;
	}
}

export default FacilityOrderTemplatePatientCreate;